/**
 * Hub PDP title rating — AOGEN /api/public/reviews aggregate.
 * Fills [data-wbw-pdp-rating] with score, star fill, and review count.
 */
(function () {
  var API_BASE = 'https://amc-ew.aogen.com.au';

  function normalizeType(raw) {
    var t = String(raw || '').toLowerCase().trim();
    if (t.indexOf('mosaic') > -1) return 'mosaic';
    if (t.indexOf('resin') > -1) return 'resin';
    if (t.indexOf('ceramic') > -1) return 'ceramic';
    if (t.indexOf('flower') > -1) return 'flower';
    return t;
  }

  function formatCount(n) {
    var count = Math.round(Number(n) || 0);
    if (count === 1) return '(1 review)';
    return '(' + count.toLocaleString('en-US') + ' reviews)';
  }

  function apply(root, avg, count) {
    var scoreEl = root.querySelector('[data-wbw-pdp-rating-score]');
    var countEl = root.querySelector('[data-wbw-pdp-rating-count]');
    var fillEl = root.querySelector('[data-wbw-pdp-rating-stars]');
    var safeAvg = Math.max(0, Math.min(5, Number(avg) || 0));
    if (scoreEl) scoreEl.textContent = safeAvg.toFixed(1);
    if (countEl) countEl.textContent = formatCount(count);
    if (fillEl) fillEl.style.width = (safeAvg / 5) * 100 + '%';
    root.removeAttribute('hidden');
    root.setAttribute(
      'aria-label',
      safeAvg.toFixed(1) + ' out of 5 from ' + Math.round(Number(count) || 0) + ' reviews'
    );
    root.setAttribute('role', 'img');
    syncHubGalleryToWizard();
  }

  function syncHubGalleryToWizard() {
    var page = document.querySelector('.product-page[data-workshop-hub-pdp]');
    var media = page && page.querySelector('.product-media-container');
    var card = page && page.querySelector('.wbw-root');
    if (!page || !media || !card) return;
    if (!window.matchMedia('(min-width: 990px)').matches) {
      page.style.removeProperty('--wbw-gallery-nudge');
      return;
    }
    var scrolled = (window.pageYOffset || window.scrollY || 0) > 8;
    if (scrolled && page.style.getPropertyValue('--wbw-gallery-nudge')) return;
    var current = parseFloat(getComputedStyle(page).getPropertyValue('--wbw-gallery-nudge'));
    if (!Number.isFinite(current)) {
      current = parseFloat(getComputedStyle(media).marginTop) || 0;
    }
    var delta = Math.round(card.getBoundingClientRect().top - media.getBoundingClientRect().top);
    var next = Math.max(0, Math.round(current + delta));
    if (Math.abs(next - current) < 1) return;
    page.style.setProperty('--wbw-gallery-nudge', next + 'px');
  }

  function bindHubGalleryAlign() {
    if (document.__wbwGalleryAlign) return;
    document.__wbwGalleryAlign = true;
    var run = function () {
      requestAnimationFrame(syncHubGalleryToWizard);
    };
    run();
    window.addEventListener('resize', run, { passive: true });
  }

  function fetchRating(root) {
    var shopDomain = (root.getAttribute('data-shop-domain') || '').trim();
    if (!shopDomain) return;
    var workshopType = normalizeType(root.getAttribute('data-workshop-type'));
    var apiUrl = (root.getAttribute('data-api-base-url') || API_BASE).replace(/\/$/, '');
    var params = new URLSearchParams();
    params.set('shop_domain', shopDomain);
    params.set('status', 'approved');
    params.set('include_google', 'true');
    params.set('include_site', 'true');
    params.set('limit', '1');
    if (workshopType) params.set('workshop_type', workshopType);

    fetch(apiUrl + '/api/public/reviews?' + params.toString())
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error('reviews request failed'));
      })
      .then(function (payload) {
        var aggregate = payload && payload.aggregate ? payload.aggregate : null;
        var avg = aggregate && aggregate.avg_rating != null ? Number(aggregate.avg_rating) : NaN;
        var count =
          aggregate && (aggregate.review_count != null || aggregate.count != null)
            ? Number(aggregate.review_count != null ? aggregate.review_count : aggregate.count)
            : NaN;
        if (!Number.isFinite(avg)) return;
        apply(root, avg, Number.isFinite(count) ? count : 0);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-wbw-pdp-rating]').forEach(function (root) {
      if (root.dataset.wbwPdpRatingInit === '1') return;
      root.dataset.wbwPdpRatingInit = '1';
      fetchRating(root);
    });
    bindHubGalleryAlign();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
